import { render, staticRenderFns } from "./feed-image.vue?vue&type=template&id=10d9410b&"
import script from "./feed-image.vue?vue&type=script&lang=js&"
export * from "./feed-image.vue?vue&type=script&lang=js&"
import style0 from "./feed-image.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports